























































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'; // initialize
import axios from 'axios';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoNavBar from '@/components/Molecules/co-navbar/CoNavBar.vue';
import CoBreadcrumbs from '@/components/Molecules/co-breadcrumbs/CoBreadcrumbs.vue';
import setCustomColors from '../../customColors';
import CoPill from '../../components/Atoms/co-pill/CoPill.vue';
import CoLink from '../../components/Atoms/co-link/CoLink.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';

export default {
    name: 'AdminBase',
    components: {
        CoNavBar,
        CoButton,
        CoBreadcrumbs,
        CoPill,
        CoLink,
        CoAlert,
        CoText,
    },
    data() {
        return {
            collapsed: false,
            adminMenuOpen: true,
            selectedMenu: null,

            menu: {
                statistics: false,
                space: false,
                community: false,
                booking: false,
                event: false,
                monetization: false,
            },
            skipNoSlider: false,
            spacePlanName: null,
            spaceApplicationFee: null,
            currentPath: '',
            featureStatus: {},
        };
    },
    computed: {
        burgerButtonIcon() {
            if (this.adminMenuOpen) {
                return 'x';
            }
            return 'list';
        },
        // any menu is open
        anyMenuOpen() {
            return this.skipNoSlider;
            // return Object.values(this.menu).some((value) => value);
        },
    },
    watch: {
        // set the path parameter for conditional styling
        $route: {
            handler(to, from) {
                if (window.innerWidth < 768) this.adminMenuOpen = false;

                setCustomColors([
                    {
                        name: 'primary',
                        value: '#5100ff',
                    },
                    {
                        name: 'primary-dark',
                        value: '#3f00c6',
                    },
                    {
                        name: 'red',
                        value: '#fd6969',
                    },
                    {
                        name: 'text',
                        value: '#212529',
                    },
                ]);

                // set language override for all admin views
                // to do: remove when all admin views are translated
                this.$i18n.locale = 'en';

                this.currentPath = to.path || '';
            },
            deep: true,
            immediate: true,
        },
        '$route.meta.breadcrumbs': {
            handler(value) {
                this.$store.commit('SET_BREADCRUMBS', value);
            },
            deep: true,
            immediate: true,
        },
        '$store.state.space': {
            // set the feature status for conditional alerts
            handler(value) {
                this.featureStatus.booking = value['BookingOn'] || false;
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        setCustomColors([
            {
                name: 'primary',
                value: '#5100ff',
            },
            {
                name: 'primary-dark',
                value: '#3f00c6',
            },
            {
                name: 'red',
                value: '#fd6969',
            },
            {
                name: 'text',
                value: '#212529',
            },
        ]);
        this.getPaymentState();
        this.getAdminSpaceSettings();
    },
    mounted() {
        if (this.$store && this.$store.state) {
            if (this.$store.state.space_configuration_admin) {
                this.spacePlanName = this.$store.state.space_configuration_admin.PlanName
                    ? this.$store.state.space_configuration_admin.PlanName.split(' ')[0]
                    : 'Legacy';
                this.spaceApplicationFee = this.$store.state.space_configuration_admin.ApplicationFee;
            }
        }

        this.breadcrumbs = this.$route.meta.breadcrumbs;

        this.$nextTick(function () {
            this.search = this.$route.query.term;
        });
    },
    // On destroy reset custom colors to default
    beforeDestroy() {
        setCustomColors([
            {
                name: 'primary',
                value: this.$store.state.space_configuration_admin.PrimaryColor || '#5100ff',
            },
            {
                name: 'primary-dark',
                value: this.$store.state.space_configuration_admin.PrimaryColor,
            },
            {
                name: 'red',
                value: this.$store.state.space_configuration_admin.SecondaryColor,
            },
            {
                name: 'text',
                value: this.$store.state.space_configuration_admin.TextColor,
            },
        ]);
    },
    methods: {
        // function check if there is a previous page and go back
        isTherePreviousPage() {
            if (this.$route.path === '/admin/dashboard/general') {
                return false;
            }
            return true;
        },

        back() {
            if (this.isTherePreviousPage()) {
                this.$router.go(-1);
            } else {
                this.$router.push('/');
            }
        },
        goToUserInterace() {
            this.$router.push('/');
        },
        menuHidden(menu) {
            this.menu[menu] = false;
            this.skipNoSlider = false;
        },

        showMenu(menu) {
            if (this.menu[menu]) {
                this.skipNoSlider = false;
                this.menu[menu] = false;
            } else {
                this.menu = {
                    statistics: false,
                    space: false,
                    community: false,
                    booking: false,
                    event: false,
                    pages: false,
                    monetization: false,
                };
                this.menu[menu] = true;
            }

            if (this.menu[menu]) {
                const submenu = document.getElementById(`${menu}-submenu-sidebar`);
                if (submenu) {
                    submenu.addEventListener('mouseleave', () => {
                        this.mouseLeave();
                    });
                }
                // get tooltip by ref for menu
                const tooltip = this.$refs[`${menu}_link_tooltip`];
                if (tooltip) {
                    tooltip.$emit('close');
                }

                setTimeout(() => {
                    this.skipNoSlider = true;
                }, 100);
            } else {
                const submenu = document.getElementById(`${menu}-submenu-sidebar`);
                submenu.removeEventListener('mouseleave', () => {});
            }
        },
        mouseLeave() {
            this.skipNoSlider = false;
            setTimeout(() => {
                this.menu = {
                    statistics: false,
                    space: false,
                    community: false,
                    booking: false,
                    event: false,
                    monetization: false,
                };
            }, 200);
        },
        // getPaymentState - returns payment service readyness state
        getPaymentState() {
            axios({
                method: 'GET',
                url: '/user/account/billing/payment-state',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$store.commit('SET_PAYMENT_READY_STATE', response.data.ChargesEnabled);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getAdminSpaceSettings() {
            axios({
                method: 'GET',
                url: '/admin/space/settings',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$store.commit('SET_SPACE_OBJECT_FOR_ADMIN', response.data);
                    }
                })
                .catch((error) => {});
        },
    },
};
